import { useState } from 'react';
import './adminpage.css'
import Employmentdata from './employmentdata/Employmentdata';
import Adminlogin from './adminlogin/Adminlogin';
import Products from './productsdta/Prodactsdata';
import Storydata from './storydata/Storydata';
import Updatedata from './updatedata/Updatedata';
import Mugramdata from './mugramdata/Mugramdata';
export default function Adminpage(props) {
    const [adminnav, setAdminnav] = useState('buys')
    const [loggedIn, setLoggedIn] = useState(false)
    function buysselect() {
        setAdminnav('buys')
    }
    function employmentselect() {
        setAdminnav('employment')
    }
    function storsselect() {
        setAdminnav('stors')
    }
    function settingselect() {
        setAdminnav('setting')
    }
    function mugramselect() {
        setAdminnav('mugram')
    }
    return (<>
        {loggedIn === false ? <Adminlogin  setLoggedIn={setLoggedIn}/> :
            <div className='adminpage'>
                <div className='adminnav'>
                    <ul>
                        <li className='buys' onClick={buysselect} style={adminnav === 'buys' ? { borderBottom: '2px solid red' } : { borderBottom: 'none' }}>استوری</li>
                        {/* <li className='employment' onClick={employmentselect} style={adminnav === 'employment' ? { borderBottom: '2px solid red' } : { borderBottom: 'none' }}>استخدام</li> */}
                        <li className='stors' onClick={storsselect} style={adminnav === 'stors' ? { borderBottom: '2px solid red' } : { borderBottom: 'none' }}>محصولات</li>
                        <li className='mugram' onClick={mugramselect} style={adminnav === 'mugram' ? { borderBottom: '2px solid red' } : { borderBottom: 'none' }}>موگرام</li>
                        <li className='setting' onClick={settingselect} style={adminnav === 'setting' ? { borderBottom: '2px solid red' } : { borderBottom: 'none' }}>تنظیمات</li>
                    </ul>
                </div>
                <div className='admindata'>{adminnav === 'buys' ? <Storydata addStory={props.addStory} stories={props.stories} removeStory={props.removeStory}/> : adminnav === 'employment' ? <Employmentdata /> : adminnav === 'stors' ? <Products /> : adminnav === 'setting' ? <Updatedata /> : <Mugramdata />}</div>
            </div>}
    </>
    )
}